export default __webpack_public_path__ + "static/media/3016.2816f0b8.jpg";